import { motion } from "framer-motion";
import koggala from "../../accests/galle/koggala.jpeg";
import madu from "../../accests/galle/madu.jpeg";
import galle from "../../accests/galle/galle (3).jpeg";
import mala from "../../accests/galle/mala.jpeg";
import tur from "../../accests/galle/tur.jpg";
import moon from "../../accests/galle/moon.jpg";
import g1 from "../../accests/galle/galle (2).jpeg";
import g2 from "../../accests/galle/galle (9).jpeg";
import g3 from "../../accests/galle/galle.jpeg";


export default function GalleDayTour() {
    const highlights = [
        {
            title: "Madu River Safari",
            desc: "Embark on a safari through the Madu River, located near Balapitiya. The river is home to lush mangrove forests, islands, and a wide variety of wildlife, including tropical birds, reptiles, and, if you’re lucky, crocodiles..",
            img: madu
        },
        {
            title: "Meetiyagoda Moonstone Mine",
            desc: "At Meetiyagoda Moonstone Mine, witness traditional moonstone mining techniques, explore Sri Lanka’s rich gemstone heritage, and learn about the cultural and historical importance of this rare and precious gem.",
            img: moon },
        {
            title: "Historic Galle Fort",
            desc: "Galle Fort is a must-see, with its colonial mansions, Dutch churches, and museums. Built by the Portuguese and fortified by the Dutch, this 17th century structure offers a glimpse into Sri Lanka’s colonial past.",
            img: galle
        },
        {
            title: "Kosgoda Turtle Hatchery",
            desc: "Begin your tour with a visit to the Kosgoda Turtle Hatchery, dedicated to preserving seven species of marine turtles. This non-profit organisation works tirelessly to protect turtle eggs and release the hatchlings back into the wild",
            img: tur
        },
        {
            title: "Stilt Fishing & Coastal Views",
            desc: "End the tour with a visit to Koggala, where you can see local fishermen practicing the ancient art of stilt fishing. Perched on poles, these fishermen balance with patience and precision to catch fish in the sea.",
            img:koggala
        },
        {
            title: "Tsunami Memorial",
            desc: "Peraliya Tsunami Memorial is situated in the coastal Peraliya village close to the Hikkaduwa town. It is built in a small island in the middle of a pond located close to the railway track which was affected by the Tsunami tragedy in 2004. This is a very stunning scene that has attracted the hearts of many.",
            img: mala
        }
    ];

    const itinerary = [
        "Pickup from your hotel along the south coast",
        "Madu River Safari to spot wildlife",
        "Visit Meetiyagoda Moonstone Mine",
        "Explore Historic Galle Fort streets",
        "Stop at Kosgoda Turtle Hatchery",
        "Photo stop at stilt fishing & beaches",
        "Lunch at a local restaurant",
        "Visit Telwatta Tsunami Memorial",
        "Return to your hotel"
    ];

    return (
        <div className="pt-28 bg-gray-50">

            {/* HERO */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
                className="relative h-[60vh]"
            >
                <img
                    src={galle}
                    alt="Galle Day Tour"
                    className="w-full h-full object-cover brightness-75"
                />
                <div className="absolute inset-0 flex flex-col justify-center items-center text-center text-white px-6">
                    <motion.h1
                        initial={{ y: -50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 1, delay: 0.3 }}
                        className="text-5xl md:text-6xl font-bold drop-shadow-lg"
                    >
                        Galle Day Tour
                    </motion.h1>
                    <motion.p
                        initial={{ y: 50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 1, delay: 0.6 }}
                        className="mt-4 max-w-2xl text-lg drop-shadow-md"
                    >
                        Discover the heart of southern Sri Lanka with history, culture, and scenic adventures.
                    </motion.p>
                </div>
            </motion.div>

            {/* HIGHLIGHTS */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="max-w-7xl mx-auto px-6 py-16">
                <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
                    Tour Highlights
                </h2>
                <div data-aos="fade-up"
                     data-aos-duration="3000" className="grid md:grid-cols-3 gap-8">
                    {highlights.map((item, index) => (
                        <motion.div
                            key={index}
                            whileHover={{ scale: 1.05 }}
                            className="bg-white rounded-3xl shadow-lg overflow-hidden transition transform"
                        >
                            <img src={item.img} alt={item.title} className="w-full h-48 object-cover"/>
                            <div className="p-6">
                                <h3 className="text-xl font-semibold text-yellow-500 mb-2">{item.title}</h3>
                                <p className="text-gray-600 text-sm">{item.desc}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </section>

            {/* ITINERARY */}
            <section className="bg-gray-100 py-16">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-start">

                    {/* LEFT – ITINERARY LIST */}
                    <div>
                        <h2 className="text-3xl font-bold mb-10 text-gray-800">
                            Detailed Itinerary
                        </h2>

                        <ul className="space-y-4 text-gray-700 list-decimal list-inside">
                            {itinerary.map((step, index) => (
                                <motion.li
                                    key={index}
                                    initial={{ x: -50, opacity: 0 }}
                                    whileInView={{ x: 0, opacity: 1 }}
                                    transition={{ duration: 0.5, delay: index * 0.1 }}
                                    className="text-lg"
                                >
                                    {step}
                                </motion.li>
                            ))}
                        </ul>
                    </div>

                    {/* RIGHT – SMALL IMAGES */}
                    <div data-aos="fade-up"
                         data-aos-duration="3000" className="grid grid-cols-2 gap-4">
                        {[madu, g1, g3, tur].map((img, i) => (
                            <motion.img
                                key={i}
                                src={img}
                                alt="Tour spot"
                                whileHover={{ scale: 1.05 }}
                                className="h-40 w-full object-cover rounded-2xl shadow-lg"
                            />
                        ))}
                    </div>

                </div>
            </section>


            {/* WHY CHOOSE THIS TOUR + CTA */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="relative py-24 overflow-hidden">

                {/* BACKGROUND IMAGE */}
                <div className="absolute inset-0">
                    <img
                        src={koggala}
                        alt="Why choose Galle tour"
                        className="w-full h-full object-cover scale-110 blur-md"
                    />
                    <div className="absolute inset-0 bg-black/60"></div>
                </div>

                {/* CONTENT */}
                <div className="relative max-w-6xl mx-auto px-6 text-white text-center">

                    <h2 className="text-3xl md:text-4xl font-bold mb-10">
                        Why Choose This Tour?
                    </h2>

                    {/* FEATURES */}
                    <ul className="max-w-3xl mx-auto space-y-4 text-lg list-disc list-inside backdrop-blur-md bg-white/10 p-8 rounded-3xl shadow-xl">
                        <li>Experience Galle’s rich history and UNESCO World Heritage charm.</li>
                        <li>Spot wildlife and sea turtles on the Madu River safari.</li>
                        <li>Learn about Sri Lanka’s unique gem industry at Meetiyagoda.</li>
                        <li>Enjoy pristine southern beaches and traditional stilt fishing.</li>
                        <li>Travel with an expert local guide sharing stories and insights.</li>
                    </ul>


                    {/* CTA */}
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="mt-14"
                    >
                        <motion.a
                            whileHover={{ scale: 1.08 }}
                            whileTap={{ scale: 0.95 }}
                            href="https://wa.me/94770163670?text=Hello%20I%20would%20like%20to%20book%20the%20Galle%20Day%20Tour"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center px-14 py-4
        bg-yellow-500 text-black font-semibold text-lg
        rounded-full shadow-xl hover:bg-yellow-400
        transition-all duration-300"
                        >
                            Book Galle Day Tour
                        </motion.a>

                        <p className="mt-4 text-sm text-gray-200">
                            📞 Custom tours • 🕒 Flexible timing • 🚗 Comfortable transport
                        </p>
                    </motion.div>



                </div>
            </section>

        </div>
    );
}
